import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { saveAs } from 'file-saver';
import { notificationInit } from '../../modules/notifications/actions';
import { getCarsListRequest, getCarTypesRequest, getBlobForReqListRequest } from '../../api/requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { DISMISS_TIME } from '../../api/constants';
import {
	GET_CAR_TYPES,
	GET_CARS_LIST,
	GET_LIST_CAR_FILE_TYPES,
	setCarsListAction,
	setCarTypesAction,
	setIsCarsListLoadingAction,
	setIsCarTypesLoadingAction,
	setPaginationAction,
	setIsDownloadLoadingAction,
} from './actions';
import { errorHandler } from '../../api/utils';

export function* getCarsListSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsCarsListLoadingAction(true));
		}
		const { data, meta, message, toast } = yield call(getCarsListRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setCarsListAction(
					data?.map(car => ({
						...car,
						type_name: car.type?.name ?? '---',
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=car&id=${car.id}`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsCarsListLoadingAction(false));
	}
}

export function* getTypesSaga() {
	try {
		yield put(setIsCarTypesLoadingAction(true));

		const { data, message, toast } = yield call(getCarTypesRequest, '?receive=all');

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(setCarTypesAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsCarTypesLoadingAction(false));
	}
}

export function* getReqListFileSaga({ payload: { exportUrl } }) {
	try {
		yield put(setIsDownloadLoadingAction(true));
		const blob = yield call(getBlobForReqListRequest, exportUrl);

		saveAs(blob, 'cars.xlsx');
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsDownloadLoadingAction(false));
	}
}
export default function* carsContainerSaga() {
	yield takeEvery(GET_CARS_LIST, getCarsListSaga);
	yield takeEvery(GET_CAR_TYPES, getTypesSaga);
	yield takeEvery(GET_LIST_CAR_FILE_TYPES, getReqListFileSaga);
}
